import React, {forwardRef, Fragment, useEffect, useImperativeHandle} from 'react';
import {Col, Form, Row, Select} from "antd";
import {GUTTER_MD, SPAN_HALF, SPAN_ONE_THIRD, SPAN_TWO_THIRDS} from "../../styles/constants";
import {useForm} from 'react-hook-form/dist/react-hook-form.ie11';
import {DataLanguageProvider, withDataLanguage} from "../../contexts/DataLanguage";
import {
  getLayoutAnnotationTerritorialDimensionIds,
  setLayoutAnnotationTerritorialDimensionIds
} from "../../utils/annotations";
import {connect} from "react-redux";
import {compose} from "redux";

const formItemLayout = {
  labelCol: {span: SPAN_ONE_THIRD},
  wrapperCol: {span: SPAN_TWO_THIRDS}
};

const DefaultMapLayout = ({
                            t,
                            forwardedRef,
                            disabled,
                            dsdDimensions,
                            annotations,
                            annotationsConfig,
                            onChange
                          }) => {

  const {register, watch, setValue, handleSubmit} = useForm({
    defaultValues: {
      territorialDimensionIds: getLayoutAnnotationTerritorialDimensionIds(annotations, annotationsConfig)[0] || null,
    }
  });

  useEffect(() => {
    register({name: 'territorialDimensionIds'});
  }, []);

  const territorialDimensionIds = watch('territorialDimensionIds');

  useEffect(() => {
    if (onChange) {

      let newLayoutAnnotations = setLayoutAnnotationTerritorialDimensionIds(
        annotations,
        annotationsConfig,
        territorialDimensionIds ? [territorialDimensionIds] : []
      );

      onChange({layoutAnnotations: newLayoutAnnotations});
    }
  }, [territorialDimensionIds])

  useImperativeHandle(forwardedRef, () => ({
    submit(annotations, cb) {
      handleSubmit(val => {

        let newLayoutAnnotations = setLayoutAnnotationTerritorialDimensionIds(
          annotations,
          annotationsConfig,
          val.territorialDimensionIds ? [val.territorialDimensionIds] : []
        );

        cb(newLayoutAnnotations);

      })();
    }
  }));


  return (
    <Fragment>
      <Form>
        <DataLanguageProvider value={null}>
          <Row gutter={GUTTER_MD}>
            <Col span={SPAN_HALF}>
              <Form.Item
                label={t('data.nodesConfig.annotations.layoutTerritorialDimensionIds.label')}
                {...formItemLayout}
              >
                <Select
                  disabled={disabled}
                  title={watch('territorialDimensionIds')}
                  value={watch('territorialDimensionIds')}
                  onChange={val => setValue('territorialDimensionIds', val)}
                >
                  <Select.Option
                    value={null}
                    title={t('layoutAnnotations.empty')}
                  >
                    {t('layoutAnnotations.empty')}
                  </Select.Option>
                  {(dsdDimensions || []).map(({id}) =>
                    <Select.Option key={id} value={id} title={id}>{id}</Select.Option>
                  )}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </DataLanguageProvider>
      </Form>
    </Fragment>
  );
};

const ConnectedDefaultMapLayout = compose(
  withDataLanguage(),
  connect(state => ({
    appLanguage: state.app.language
  })))(DefaultMapLayout);

export default forwardRef(
  (props, ref) =>
    <ConnectedDefaultMapLayout {...props} forwardedRef={ref}/>
);


// WEBPACK FOOTER //
// ./src/components/layout-annotations-form/DefaultMapLayout.jsx